import React from "react";
import { Badge } from "@/components/ui/badge";

const INSTALLATION_STATUS = {
  ok:                { label: "Conforme",          className: "bg-green-100 text-green-700" },
  pending_inspection:{ label: "Pendent inspecció", className: "bg-yellow-100 text-yellow-700" },
  expired:           { label: "Caducat",           className: "bg-red-100 text-red-700" },
  deficiency_minor:  { label: "Defic. lleu",       className: "bg-orange-100 text-orange-700" },
  deficiency_major:  { label: "Defic. greu",       className: "bg-red-100 text-red-700" },
  inactive:          { label: "Inactiu",           className: "bg-gray-100 text-gray-500" },
};

const INSPECTION_RESULT = {
  favorable:                { label: "Favorable",          className: "bg-green-100 text-green-700" },
  favorable_with_conditions:{ label: "Favorable c/ cond.", className: "bg-yellow-100 text-yellow-700" },
  unfavorable:              { label: "Desfavorable",       className: "bg-red-100 text-red-700" },
  pending:                  { label: "Pendent",            className: "bg-gray-100 text-gray-500" },
};

const SEVERITY = {
  lleu:      { label: "Lleu",      className: "bg-yellow-100 text-yellow-700" },
  greu:      { label: "Greu",      className: "bg-orange-100 text-orange-700" },
  molt_greu: { label: "Molt greu", className: "bg-red-100 text-red-700" },
};

const DEFICIENCY_STATUS = {
  open:          { label: "Oberta",         className: "bg-red-100 text-red-700" },
  in_progress:   { label: "En curs",        className: "bg-blue-100 text-blue-700" },
  resolved:      { label: "Resolta",        className: "bg-green-100 text-green-700" },
  accepted_risk: { label: "Risc acceptat",  className: "bg-gray-100 text-gray-600" },
};

export function InstallationStatusBadge({ status }) {
  const cfg = INSTALLATION_STATUS[status] || { label: status, className: "bg-gray-100 text-gray-500" };
  return <Badge className={cfg.className}>{cfg.label}</Badge>;
}

export function InspectionResultBadge({ result }) {
  const cfg = INSPECTION_RESULT[result] || { label: result, className: "bg-gray-100 text-gray-500" };
  return <Badge className={cfg.className}>{cfg.label}</Badge>;
}

export function SeverityBadge({ severity }) {
  const cfg = SEVERITY[severity] || { label: severity, className: "bg-gray-100 text-gray-500" };
  return <Badge className={cfg.className}>{cfg.label}</Badge>;
}

export function DeficiencyStatusBadge({ status }) {
  const cfg = DEFICIENCY_STATUS[status] || { label: status, className: "bg-gray-100 text-gray-500" };
  return <Badge className={cfg.className}>{cfg.label}</Badge>;
}